import 'bootstrap/dist/js/bootstrap.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import moment from 'moment';
import App from './App';
// import './components/public/bootstrap/dist/css/bootstrap.css';
// import './components/public/bootstrap/dist/js/bootstrap.js';

// PrimeReact
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

// (اختياري) CSS الخاص بك
import "./index.css";
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { PrimeReactProvider } from 'primereact/api';

// // تهيئة التوقيت ليكون بتوقيت ليبيا (UTC+2) بشكل افتراضي لجميع كائنات moment
// moment.updateOffset = function (m) {
//   if (m._offset !== 120) {
//     const isInstant = m._i === undefined ||
//       m._i instanceof Date ||
//       typeof m._i === 'number' ||
//       (typeof m._i === 'string' && (m._i.indexOf('Z') !== -1 || /[+-]\d\d:?\d\d/.test(m._i)));

//     m.utcOffset(120, !isInstant);
//   }
// };

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <PrimeReactProvider>
    <Router >
      <App />
    </Router>
  </PrimeReactProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
